export const StatusOperationalConstant = {
    ACTIVE: 'ACTIVE',
    ARRIVED: 'ARRIVED',
    CANCELLED: 'CANCELLED',
    DELAYED: 'DELAYED',
    DELIVERED: 'DELIVERED',
    DEPARTED: 'DEPARTED',
    INACTIVE: 'INACTIVE'
}